@if (node2 | async; as item) {
  <div class="fluad-firstvideo">
    @if (item.uid=='SeqirusFluadFirstComponent') {
      <section class="landingpage_videoContainer d-none d-md-block">
        <video #videoPlayer muted="" preload="auto" autoplay="" playsinline=""  title="shield of adjuvant advantage" class="flucelvaxAdjAdvVideo" type="video/mp4">
            <source [src]="getVideo(item?.mediaVideo)" type="video/mp4">
        </video>
    </section>
    }
    @if (item.uid=='SeqirusFluadFirstMobComponent') {
      <section class="landingpage_videoContainer d-md-none d-block">
        <video #videoPlayer muted="" preload="auto" autoplay="" playsinline="" title="shield of adjuvant advantage" class="flucelvaxAdjAdvVideo" type="video/mp4">
            <source [src]="getVideo(item?.mediaVideo)" type="video/mp4">
        </video>
      </section>
    }
  </div>
}
